export default __webpack_public_path__ + "static/media/quinoa.897aacb5.jpg";